<div class="one-column-body">
    <ng-content select="[body]"></ng-content>
</div>


